import {
  Button as AntButton,
  Descriptions,
  Modal,
  Select,
  Table,
  TableColumnsType,
} from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorResponse from '../ErrorResponse';
import useAxios from '../../hooks/useAxios';
import {
  IExamPaperParams,
  IGetExamPapers,
  IGetExamPurposes,
  IGetTestSubjects,
} from '../../models/testCenter.model';
import {
  getExamPapers,
  getExamPurposes,
  getTestSubjects,
  updateExamPaper,
} from '../../api/testCenter.api';
import Pagination from '../../components/Pagination';
import config from '../../lib/config';
import Radio from '../Radio';
import useNotification from '../../hooks/useNotification';
import Loader from '../Loader';
import useCommonCode from '../../hooks/useCommonCode';
import Button from '../Button';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  examSubjectCode: number | undefined;
  doGetExamSubjects: () => void;
}

const SelectPaperModal: FC<IProps> = ({
  visible,
  setVisible,
  examSubjectCode,
  doGetExamSubjects,
}) => {
  const { t } = useTranslation();
  const { getDetailCode } = useCommonCode();
  // SY0005 = 연도
  const SY0005 = getDetailCode('SY0005');
  // SY0011 = 회차
  const SY0011 = getDetailCode('SY0011');

  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetExamPapers>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetTestSubjects>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetExamPurposes>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();

  const [data, setData] = useState<any>();
  const [page, setPage] = useState(1);
  const [yearCode, setYearCode] = useState<string>();
  const [timeCode, setTimeCode] = useState<string>();
  const [subjectCode, setSubjectCode] = useState<string>();
  const [examPaperBrnCode, setExamPaperBrnCode] = useState<string>();
  const [testTitle, setTestTitle] = useState<string>();

  const [testCode, setTestCode] = useState<number>();
  const [subjectTime, setSubjectTime] = useState<string>();

  useEffect(() => {
    execute2(getTestSubjects());
    execute3(getExamPurposes());
  }, []);

  useEffect(() => {
    if (res && !isLoading) {
      setData(res.data);
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetExamSubjects();
      successNotification(t('common.message.save1'));
      onClose();
    }
  }, [submitRes, submitIsLoading]);

  const onSearch = () => {
    if (
      !yearCode &&
      !timeCode &&
      !subjectCode &&
      !examPaperBrnCode &&
      !testTitle
    ) {
      return infoNotification(t('cbt.test.message6'));
    }

    const req: IExamPaperParams = {};
    if (yearCode) req.yearCode = yearCode;
    if (timeCode) req.timeCode = timeCode;
    if (subjectCode) req.subjectCode = subjectCode;
    if (examPaperBrnCode) req.examPaperBrnCode = examPaperBrnCode;
    if (testTitle) req.testTitle = testTitle;

    execute(getExamPapers(req));
  };

  const onSubmit = () => {
    if (!examSubjectCode) return;

    if (!testCode) {
      return infoNotification(t('cbt.test.message7'));
    }
    if (!subjectTime) {
      return infoNotification(t('cbt.test.message8'));
    }

    submitExecute(
      updateExamPaper(examSubjectCode, {
        testCode,
        subjectTime: Number(subjectTime) * 60,
      }),
    );
  };

  const onClose = () => {
    setData(undefined);
    setYearCode(undefined);
    setTimeCode(undefined);
    setSubjectCode(undefined);
    setExamPaperBrnCode(undefined);
    setTestTitle(undefined);
    setTestCode(undefined);
    setSubjectTime(undefined);
    setVisible(false);
  };

  const columns: TableColumnsType<any> = [
    {
      title: '',
      dataIndex: 'testCode',
      key: 'testCode',
      align: 'center',
      render: (value: number) => (
        <Radio
          checked={value === testCode}
          onChange={() => setTestCode(value)}
          text=""
        />
      ),
    },
    {
      title: t('cbt.test.column17'),
      key: 'testCode',
      dataIndex: 'testCode',
      align: 'center',
    },
    {
      title: 'Title',
      dataIndex: 'testTitle',
      key: 'testTitle',
      align: 'center',
    },
    {
      title: t('cbt.test.column7'),
      dataIndex: 'yearCode',
      key: 'yearCode',
      align: 'center',
    },
    {
      title: t('cbt.speakTest.column5'),
      dataIndex: 'timeCode',
      key: 'timeCode',
      align: 'center',
    },
    {
      title: t('cbt.type.column5'),
      dataIndex: 'subjectName',
      key: 'subjectName',
      align: 'center',
    },
    {
      title: t('cbt.test.column15'),
      dataIndex: 'quizCount',
      key: 'quizCount',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading || isLoading2 || isLoading3 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={submitError} />

      <Modal
        title={t('cbt.test.title4')}
        visible={visible}
        onCancel={onClose}
        width={750}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic pink' onClick={onSubmit}>
              {t('cbt.test.button1')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={onClose}>
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex">
          <div className="w-100">
            <div className='comm-table__area rowType mt-0'>
            <Descriptions
              bordered
              size="small"
              column={2}
              labelStyle={{ width: '12.5%' }}
              contentStyle={{ width: '37.5%' }}
            >
              <Descriptions.Item label={t('cbt.test.column7')}>
                <Select
                  className="w-100"
                  placeholder={t('common.button.select')}
                  value={yearCode}
                  onChange={(value) => setYearCode(value)}
                >
                  <Select.Option value="">{t('common.text.all')}</Select.Option>
                  {[...SY0005].reverse().map((item) => (
                    <Select.Option
                      key={item.detailCode}
                      value={item.detailCode}
                    >
                      {item.korName}
                    </Select.Option>
                  ))}
                </Select>
              </Descriptions.Item>
              <Descriptions.Item label={t('cbt.speakTest.column5')}>
                <Select
                  className="w-100"
                  placeholder={t('common.button.select')}
                  value={timeCode}
                  onChange={(value) => setTimeCode(value)}
                >
                  <Select.Option value="">{t('common.text.all')}</Select.Option>
                  {SY0011?.map((item) => (
                    <Select.Option
                      key={item.detailCode}
                      value={item.detailCode}
                    >
                      {item.korName}
                    </Select.Option>
                  ))}
                </Select>
              </Descriptions.Item>
              <Descriptions.Item label={t('cbt.type.column5')}>
                <Select
                  className="w-100"
                  placeholder={t('common.button.select')}
                  value={subjectCode}
                  onChange={(value) => setSubjectCode(value)}
                >
                  <Select.Option value="">{t('common.text.all')}</Select.Option>
                  {res2?.data.map((item) => (
                    <Select.Option
                      key={item.subjectCode}
                      value={item.subjectCode}
                    >
                      {item.subjectName}
                    </Select.Option>
                  ))}
                </Select>
              </Descriptions.Item>
              <Descriptions.Item label="Purpose">
                <Select
                  className="w-100"
                  placeholder={t('common.button.select')}
                  value={examPaperBrnCode}
                  onChange={(value) => setExamPaperBrnCode(value)}
                >
                  <Select.Option value="">{t('common.text.all')}</Select.Option>
                  {res3?.data.map((item) => (
                    <Select.Option
                      key={item.examPaperBrnCode}
                      value={item.examPaperBrnCode}
                    >
                      {item.codeName}
                    </Select.Option>
                  ))}
                </Select>
              </Descriptions.Item>
              <Descriptions.Item label="Title" span={2}>
                <input
                  type="text"
                  className="form-control input-text"
                  value={testTitle}
                  onChange={(e) => setTestTitle(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') onSearch();
                  }}
                />
              </Descriptions.Item>
            </Descriptions>
            </div>
          </div>
          <div className="w-60p pl-1">
            <Button
              className="btn btn-secondary btn-wh100"
              onClick={onSearch}
              text={t('common.button.search')}
            />
          </div>
        </div>
        {data ? (
          <>
            <div className='comm-table__area'>
              <Table
                columns={columns}
                dataSource={data}
                pagination={{
                  current: page,
                  pageSize: config.miniPageSize,
                }}
                rowKey="testCode"
              />
            </div>
            <div className="common-paging center">
              <Pagination
                count={data?.length || 0}
                page={page}
                setPage={setPage}
              />
            </div>
            <div className="text-center flex flex-justify-center">
              <span className="v-line mr-1 mt-1">{t('cbt.test.column16')}</span>
              <div className="w-100p">
                <input
                  type="number"
                  className="form-control"
                  value={subjectTime}
                  onChange={(e) => setSubjectTime(e.target.value)}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="mt-4 text-center">
            {t('cbt.test.text3')}
          </div>
        )}
      </Modal>
    </>
  );
};

export default SelectPaperModal;
